
import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { WebhookEditNodeComponent } from "../webhook-edit-node/webhook-edit-node.component";
import { EFResizeHandleType } from "@foblex/flow";
import { NzModalService } from "ng-zorro-antd/modal";
import { LanguageServices } from "src/app/services/LanguageServices";


@Component({
    selector: 'webhook-edit-node-group',
    templateUrl: './webhook-edit-node-group.component.html',
    styleUrl: './webhook-edit-node-group.component.scss',
    standalone: false
})

export class WebhookEditNodeGroupComponent extends WebhookEditNodeComponent  implements AfterViewInit {
    public eResizeHandleType =  EFResizeHandleType;
    constructor(protected ls:LanguageServices,protected modal:NzModalService) {
       super(ls,modal);
    }

    ngAfterViewInit(): void {
        
    }


}